import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Undo2 } from "lucide-react";
import { safePath } from "../lib/nav";
import { flashRecord, focusOdak } from "../lib/notify";

const PAGE_NAMES = { "/muhasebe": "Muhasebe", "/butce": "Bütçe", "/odeme-plani": "Ödeme Planı", "/proje-maliyet": "Proje Maliyet Özeti", "/kesilen-faturalar": "Kesilen Faturalar", "/veri-girisi": "Veri Girişi", "/mali-veriler": "Mali Veriler", "/musteri-hakedis": "Müşteri Hakedişi", "/taseron-hakedis": "Taşeron Hakedişi", "/tanimlar/projeler": "Projeler", "/dashboard": "Dashboard" };
const pageName = (don) => PAGE_NAMES[new URL(don, window.location.origin).pathname] || "önceki ekran";
const inField = (t) => !!t?.closest?.("input,textarea,select,[contenteditable],[data-searchable]");

// Uygulama geneli: ?kayit=<id> → satırı vurgula; ?odak=<anahtar> → [data-odak] öğesine dön (bulununca odak parametresi URL'den düşer);
// ?don= varken ESC → o adrese (aynı filtrelerle) dön; kayıt/odak yoksa da geçerli (ör. Muhasebe bağlantılarından gidilen ekranlar) ve alt ortada "Geri Dön" pili görünür.
// Sayfanın kendi dönüş şeridi varsa ([data-return-bar]) genel pil ve ESC devreye girmez. Toast bağlantıları "pas:navigate" olayıyla SPA içinde yönlendirilir.
export function RecordFlashAgent() {
  const location = useLocation();
  const navigate = useNavigate();
  const [pill, setPill] = useState(null);
  useEffect(() => {
    const h = (e) => navigate(e.detail);
    window.__pasNav = true;
    window.addEventListener("pas:navigate", h);
    return () => { window.__pasNav = false; window.removeEventListener("pas:navigate", h); };
  }, [navigate]);
  useEffect(() => {
    const p = new URLSearchParams(location.search);
    const id = p.get("kayit"), don = safePath(p.get("don")), odak = p.get("odak");
    const cancel = id ? flashRecord(id) : null;
    const cancelOdak = odak ? focusOdak(odak, () => { p.delete("odak"); navigate({ pathname: location.pathname, search: p.toString() }, { replace: true }); }) : null;
    const ownBar = () => !!document.querySelector("[data-return-bar]");
    const generic = !!don && !id && !odak;
    const t = setTimeout(() => setPill(generic && !ownBar() ? don : null), 150);
    const onKey = (e) => {
      if (e.key !== "Escape") return;
      if (id || odak) { if (don) navigate(don); else if (window.history.length > 1) navigate(-1); else navigate("/butce"); return; }
      if (generic && !inField(e.target) && !ownBar()) { e.preventDefault(); navigate(don); }
    };
    window.addEventListener("keydown", onKey, true);
    return () => { clearTimeout(t); cancel?.(); cancelOdak?.(); window.removeEventListener("keydown", onKey, true); };
  }, [location.key, location.search, location.pathname, navigate]);
  if (!pill) return null;
  return (
    <button type="button" onClick={() => navigate(pill)} data-testid="global-return-pill" title={`${pageName(pill)} ekranına aynı filtrelerle dön (ESC)`}
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 inline-flex items-center gap-2 px-3.5 py-2 rounded-full bg-slate-900 text-white text-xs font-semibold shadow-lg shadow-slate-900/30 hover:bg-slate-700 transition-colors">
      <Undo2 className="w-3.5 h-3.5" /> {pageName(pill)} ekranına geri dön <kbd className="px-1.5 py-0.5 rounded bg-slate-700 text-[10px] font-mono">ESC</kbd>
    </button>
  );
}
